/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { styled } from "@mui/system";

const globalCss = require("assets/theme/base/globals");

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Settings page components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import DataTable from "Tables/DataTable";
import AdvancedSettlementFilters from "./components/Filters";

// import BasicInfo from "./components/BasicInfo";
// import ChangePassword from "./components/ChangePassword";
// import DeleteAccount from "./components/DeleteAccount";

// react-router components

import { getData, postData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";
import { useSoftUIController } from "context";

// sweetalert2 components

import DialogBox from "Modals/CheckLeavePage";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
    marginLeft: "15px",
  },
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

let settlementOutcomes = [];

function AdvancedSettlement() {
  const css = globalCss ? globalCss.default : null;
  const customColors = css.customColors;
  const userData = getUserData();
  const [controller, dispatch] = useSoftUIController();
  const { providers } = controller;

  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [filterToggle, setFilterToggle] = useState(true);
  const [applyFilters, setApplyFilters] = useState(false);
  const [displayData, setDisplayData] = useState(false);
  const [selectedFixture, setSelectedFixture] = useState(null);

  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [modeChanges, setModeChanges] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [provider, setProvider] = useState(null);
  const [providerColor, setProviderColor] = useState("transparent");
  const [selectedUuid, setSelectedUuid] = useState(null);

  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(showDialog);

  const [loading, setLoading] = useState(false);

  const [settlementOrigins, setSettlementOrigins] = useState([
    { value: 1, label: "Live Settlement" },
    { value: 3, label: "Operator" },
    { value: 2, label: "Statistics Settlement" },
  ]);

  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "UUID", accessor: "odd_id", width: "100px", Cell: formatUuid },
      {
        Header: "Market Name",
        accessor: "market_name",
        width: "100px",
        Cell: formatCell,
      },
      // { Header: "Market Numbers", accessor: "numbers", width: "100px", Cell: mergeArray },
      { Header: "odd.e", accessor: "e", width: "100px", Cell: renderProperties },
      { Header: "odd.h", accessor: "h", width: "100px", Cell: renderProperties },
      { Header: "odd.o", accessor: "o", width: "100px", Cell: renderProperties },
      { Header: "odd_name", accessor: "odd_name", width: "100px", Cell: renderCell },
      { Header: "Platform", accessor: "platform_name", width: "100px" },
      { Header: "Outcome", accessor: "settlement", width: "80px", Cell: formatSettlement },
      {
        Header: "Send at",
        accessor: "b_created_at",
        width: "100px",
        Cell: formatDateStringUTCtoLocaleCell,
      },
    ],

    rows: [],
  });
  const [hiddenColumns, setHiddenColumns] = useState([]);

  const platforms = userData
    ? userData.platforms
      ? userData.platforms.map((platform) => ({
          value: platform.id,
          label: platform.name,
          logo: platform.logo,
          sorting: platform.sorting,
          odds_styles: platform.odds_styles,
        }))
      : []
    : [];

  async function formatPlatform({ value, ...rest }) {
    return (
      <div>
        <span>{value.toString()}</span>
      </div>
    );
  }

  async function fetchBetsOdds(filters, reset) {
    if (!reset) setDisplayData(false);
    let filtersToSend = { ...filters };
    if (!reset) setFilterToggle(true);
    setLoadingData(true);
    setLoading(true);

    let getOddsEndpoint = `/api/v1/settlements/odd`;
    let response = await postData(getOddsEndpoint, filtersToSend, {
      Authorization: getAuthorizationHeader(),
    });
    if (response != null) {
      //console.log(response.data);

      if (response.data.length == 0) {
        setApiresponse("error");
        setApiResponseMsg("There are NO Data for the selected filters.");
        setNotification(true);
        setLoadingData(false);
        setLoading(false);
        return;
      }

      let dataTable = { ...dataTableData };
      setDataTableData({ columns: [], rows: [] });
      await sleep(1000);
      dataTable.rows = response.data;
      setHiddenColumns(["updated", "sort"]);
      setDataTableData(dataTable);
      if (dataTable.rows.length > 0 && !reset) setFilterToggle(false);
      if (!reset) setDisplayData(true);
      setLoadingData(false);
      setLoading(false);
    }
  }

  async function fetchSettlementValues() {
    let settlementOutcomesEndPoint = `/api/v1/entities/availableSettlementOutcomes`;
    let response = await getData(settlementOutcomesEndPoint, {
      Authorization: getAuthorizationHeader(),
    });
    if (response != null) {
      //console.log(response.data);
      const noneOption = [{ value: 0, label: "Select..." }];
      const apiOptions = response.data.map((item) => {
        return { value: item.id, label: item.description };
      });

      const allOptions = noneOption.concat(apiOptions);

      settlementOutcomes = allOptions.map((item) => {
        return { value: item.value, label: item.label };
      });
    }
  }

  function formatDate({ value, ...rest }) {
    if (!value) return "-";
    let dateString = value.split(".")[0].replace("T", " ");
    return dateString;
  }

  function formatDateStringUTCtoLocale(value) {
    if (!value) return "-";
    let date = new Date(value);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let secs = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    let milisecs =
      date.getMilliseconds() < 100
        ? "0" + date.getMilliseconds()
        : date.getMilliseconds() < 10
        ? "00" + date.getMilliseconds()
        : date.getMilliseconds();

    let dateformatted =
      day +
      "/" +
      month +
      "/" +
      date.getFullYear() +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      secs +
      "." +
      milisecs;
    return dateformatted;
  }

  function formatDateStringUTCtoLocaleCell({ value, ...rest }) {
    if (!value) return "-";
    let date = new Date(value);
    let dateformatted = formatDateStringUTCtoLocale(value);

    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    let operator =
      rest.column.id == "settlement_date" ? rest.row.original.settled_by_operator : false;

    let betdate = rest.column.id == "created_at" ? true : false;
    let betMoment = null;
    if (betdate) {
      betMoment = "pre";
      if (date.getTime() > rest.row.original.start_date_utc * 1) betMoment = "live";
    }
    return (
      <div className={betMoment ? betMoment + "-bet" : ""}>
        {dateformatted}
        <Icon style={{ display: operator ? "" : "none", color: "#17c1e8" }}>person_icon</Icon>
      </div>
    );
  }

  function formatUuid({ value, ...rest }) {
    return (
      <div style={{ cursor: "pointer" }} onClick={(e) => handleUUIDCopy(e, value)}>
        <span className="info-icon">{value.toString().substring(1, 10) + "..."}</span>
        <Icon className="info-icon">copy</Icon>
      </div>
    );
  }

  function formatCell({ value, ...rest }) {
    return (
      <div className="cell-width">
        <HtmlTooltip
          placement="right"
          title={
            <React.Fragment>
              <div style={{ display: "flex", flexWrap: "wrap" }}>{rest.row.original.uni_name}</div>
            </React.Fragment>
          }
        >
          <div>
            <div>{value}</div>
            <Icon
              style={{
                display: rest.row.original.fast_market ? "" : "none",
                color: "forestgreen",
              }}
            >
              bolt_outlined_icon
            </Icon>
            <Icon
              style={{
                display: rest.row.original.players_market ? "" : "none",
                color: "forestgreen",
              }}
            >
              directions_run_outlined_icon
            </Icon>
          </div>
        </HtmlTooltip>
      </div>
    );
  }

  function renderProperties({ value, ...rest }) {
    return (
      <div style={{ color: value == "over" ? "green" : value == "under" ? "red" : "" }}>
        {value}
      </div>
    );
  }

  function renderCell({ value, ...rest }) {
    return <div className="cell-width">{value}</div>;
  }

  function formatSettlement({ value, ...rest }) {
    return (
      <div>
        <span>{settlementOutcomes.find((item) => item.value === value).label}</span>
      </div>
    );
  }

  const handleBetsFilters = (filters, reset) => {
    setSelectedUuid(filters.uuid);
    fetchBetsOdds(filters, reset);
  };

  async function resetData() {
    if (applyFilters) setApplyFilters(false);
    if (!applyFilters) setApplyFilters(true);
    setShowDialog(false);
  }

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  /**
   *
   */
  const handleUUIDCopy = (e, UUID) => {
    //console.log("Copy ApiKey: ", apikey);
    copyToClipboard(UUID);
  };

  const copyToClipboard = (textToCopy) => {
    setApiresponse("success");
    setApiResponseMsg("UUID has been copied to the clipboard!");
    setNotification(true);
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  
  useEffect(() => {
    fetchSettlementValues();
  }, []);

  return (
    <DashboardLayout>
      <DialogBox
        // @ts-ignore
        showDialog={showPrompt}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
      />
      <DashboardNavbar />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <SoftBox my={3} sx={{ marginBottom: "0px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12} sx={{ marginLeft: "0px !important" }}>
            <AdvancedSettlementFilters
              applyFilters={applyFilters}
              settlementOutcomes={settlementOutcomes}
              forceToggle={filterToggle}
              informParent={handleBetsFilters}
              loadingData={loadingData}
            ></AdvancedSettlementFilters>
            <SoftBox style={{ display: displayData ? "" : "none" }}>
              <Grid container spacing={0}>
                <Card style={{ width: "100%" }}>
                  <Grid item xs={12} sx={{ paddingTop: "0px", height: "100%" }}>
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      pt={2}
                      pl={3}
                      pr={3}
                    >
                      <SoftBox lineHeight={1}>
                        <SoftTypography variant="h5" fontWeight="medium">
                          Settlements for: {selectedUuid}
                        </SoftTypography>
                        <SoftTypography variant="button" fontWeight="regular" color="text">
                          Here you can find all send{" "}
                          <span style={{ color: "#cb0c9f" }}>Settlements</span> for the selected Odd
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    <DataTable
                      table={dataTableData}
                      bodyClassName="settlement-fixtures-list"
                      entriesPerPage={{
                        defaultValue: 10,
                        entries: [5, 10, 15, 20, 25],
                      }}
                      hiddenColumns={hiddenColumns}
                      headerClassName="sticky-header"
                      autoResetPageDefault={true}
                      autoResetGlobalFilter={true}
                      autoResetSortBy={true}
                      canSearch
                      tableName="live-settlement"
                      tableClassName="live-settlement-table"
                      openBackDrop={loading}
                    ></DataTable>
                  </Grid>
                </Card>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default AdvancedSettlement;
